
import Vue from "vue";

export default Vue.extend({
  name: "Admin",
  data() {
    return {
      authenticated: false,
      password: "",
      error: "",
      projects: [] as any[],
      settings: { footerText: "" },
      editingProject: null as any,
      editingFooter: false,
      showLibrary: false,
      existingFiles: [] as string[],
      currentUploadType: '',
      draggedIndex: -1,
      visualData: {
        intro: "",
        youtubeId: "",
        showApple: false,
        appleUrl: "",
        showGoogle: false,
        googleUrl: "",
        screenshots: [] as string[]
      },
      apiUrl: "/api/projects.php",
      uploadUrl: "/api/upload.php",
      settingsUrl: "/api/settings.php",
      listUrl: "/api/list_files.php"
    };
  },
  created() {
    const savedPass = localStorage.getItem("admin_pass");
    if (savedPass) {
      this.password = savedPass;
      this.login();
    }
  },
  methods: {
    async login() {
      try {
        const res = await fetch(this.apiUrl, { headers: { "Authorization": this.password } });
        if (res.ok) {
          this.projects = await res.json();
          this.authenticated = true;
          localStorage.setItem("admin_pass", this.password);
          this.error = "";
          this.loadSettings();
        } else {
          this.error = "Unauthorized";
          localStorage.removeItem("admin_pass");
        }
      } catch (e) { this.error = "Connection failed"; }
    },
    async loadSettings() {
      try {
        const res = await fetch(this.settingsUrl);
        if (res.ok) this.settings = await res.json();
      } catch (e) { console.error(e); }
    },
    async openLibrary(type: string) {
      this.currentUploadType = type;
      const res = await fetch(this.listUrl);
      if (res.ok) {
        this.existingFiles = await res.json();
        this.showLibrary = true;
      }
    },
    selectFile(url: string) {
      if (this.currentUploadType === 'icon') this.editingProject.iconUrl = url;
      else if (this.currentUploadType === 'preview') this.editingProject.previewUrl = url;
      else if (this.currentUploadType === 'screenshot') this.visualData.screenshots.push(url);
      this.showLibrary = false;
    },
    logout() {
      this.authenticated = false;
      this.password = "";
      localStorage.removeItem("admin_pass");
    },
    pickFile(type: string) {
      this.currentUploadType = type;
      (this.$refs.fileInput as any).click();
    },
    isVideo(url: string) { return url && url.toLowerCase().endsWith('.mp4'); },
    addNewProject() {
      this.editingProject = {
        id: "project-" + Date.now(),
        name: "",
        iconUrl: "",
        previewUrl: "",
        accentColor: "#1895DD",
        isHigh: false, isWide: false, isNew: true
      };
      this.visualData = { intro: "", youtubeId: "", showApple: false, appleUrl: "", showGoogle: false, googleUrl: "", screenshots: [] };
    },
    editProject(project: any) {
      this.editingProject = JSON.parse(JSON.stringify(project));
      this.editingProject.isNew = false;
      if (!this.editingProject.previewUrl) this.editingProject.previewUrl = project.iconUrl;
      this.parseHtml(project.htmlDescription);
    },
    parseHtml(html: string) {
      const div = document.createElement('div');
      div.innerHTML = html;
      const intro = div.querySelector('.paragraph')?.innerHTML.replace(/<img[^>]*>/g, "").trim() || "";
      const ytSrc = div.querySelector('iframe')?.getAttribute('src') || "";
      const youtubeId = ytSrc.split('/').pop() || "";
      const apple = div.querySelector('a[href*="apple.com"]')?.getAttribute('href') || "";
      const google = div.querySelector('a[href*="play.google.com"]')?.getAttribute('href') || "";
      const screenshots = Array.from(div.querySelectorAll('img.phone-screenshot')).map(img => img.getAttribute('src') || "");
      this.visualData = { intro, youtubeId, showApple: !!apple, appleUrl: apple, showGoogle: !!google, googleUrl: google, screenshots };
    },
    generateHtml() {
      let html = `<div class="paragraph">\n <img src="${this.editingProject.iconUrl}" width="180" height="180" align="left" style="margin-right: 20px; border-radius: 30px;">\n ${this.visualData.intro.replace(/\n/g, '<br>')}\n</div>\n`;
      if (this.visualData.youtubeId) {
        html += `<div class="paragraph center">\n <iframe class="youtube" src="https://www.youtube.com/embed/${this.visualData.youtubeId}" frameborder="0" allowfullscreen></iframe>\n</div>\n`;
      }
      if (this.visualData.showApple || this.visualData.showGoogle) {
        html += `<div class="paragraph center">\n`;
        if (this.visualData.showApple) html += ` <a href="${this.visualData.appleUrl}" target="_blank"><img src="img/projects/app-store-logo.png" width="250" /></a>\n`;
        if (this.visualData.showGoogle) html += ` <a href="${this.visualData.googleUrl}" target="_blank"><img src="img/projects/play-store-logo.png" width="250" /></a>\n`;
        html += `</div>\n`;
      }
      if (this.visualData.screenshots.length > 0) {
        html += `<div class="paragraph center">\n`;
        this.visualData.screenshots.forEach(s => { html += ` <img class="phone-screenshot" src="${s}" />\n`; });
        html += `</div>\n`;
      }
      return html;
    },
    removeScreenshot(idx: number) { this.visualData.screenshots.splice(idx, 1); },
    openFooterEditor() { this.editingFooter = true; },
    async saveProject() {
      this.editingProject.htmlDescription = this.generateHtml();
      const idx = this.projects.findIndex(p => p.id === this.editingProject.id);
      if (idx !== -1) Vue.set(this.projects, idx, this.editingProject);
      else this.projects.push(this.editingProject);
      await this.syncWithServer();
      this.editingProject = null;
    },
    async saveSettings() {
      const res = await fetch(this.settingsUrl, { method: "POST", headers: { "Content-Type": "application/json", "Authorization": this.password }, body: JSON.stringify(this.settings) });
      if (res.ok) { this.editingFooter = false; alert("Saved!"); }
    },
    async deleteProject(project: any) {
      if (confirm(`Delete ${project.name}?`)) {
        this.projects = this.projects.filter(p => p.id !== project.id);
        await this.syncWithServer();
      }
    },
    async syncWithServer() {
      try {
        await fetch(this.apiUrl, { method: "POST", headers: { "Content-Type": "application/json", "Authorization": this.password }, body: JSON.stringify(this.projects) });
      } catch (e) { console.error("Sync failed", e); }
    },
    async uploadFile(event: any) {
      const file = event.target.files[0];
      if (!file) return;
      const formData = new FormData();
      formData.append("file", file);
      const res = await fetch(this.uploadUrl, { method: "POST", headers: { "Authorization": this.password }, body: formData });
      const data = await res.json();
      if (data.status === "success") {
        if (this.currentUploadType === 'icon') this.editingProject.iconUrl = data.url;
        else if (this.currentUploadType === 'preview') this.editingProject.previewUrl = data.url;
        else if (this.currentUploadType === 'screenshot') this.visualData.screenshots.push(data.url);
      }
    },
    onDragStart(index: number) {
      this.draggedIndex = index;
    },
    onDragEnter(index: number) {
      if (this.draggedIndex !== index) {
        const items = this.projects.slice();
        const draggedItem = items.splice(this.draggedIndex, 1)[0];
        items.splice(index, 0, draggedItem);
        this.projects = items;
        this.draggedIndex = index;
      }
    },
    async onDrop() {
      await this.syncWithServer();
    }
  }
});
